import React, { useEffect, useRef } from 'react'
import styles from '../../../styles/LandingPagev1/common.module.css';
import { useState } from 'react';
import ReactDOM from 'react-dom'

export default function EnquiryDropdown(props) {
    const { options, setEnquiryOpen, enquiryOpen, actionButtonRef, avoidOverlapRef, onOptionSelect, direction = 'top' } = props;
    const dropdownRef = useRef(null);
    const [positionReady, setPositionReady] = useState(false);
    const [dropdownPos, setDropdownPos] = useState({ left: 0, bottom: 0, top: 0, width: 0 });
    useEffect(() => {
        const updatePosition = () => {
            if (actionButtonRef.current) {
                const rect = actionButtonRef.current.getBoundingClientRect();
                const avoidRect = avoidOverlapRef?.current?.getBoundingClientRect();
                const anchorTop = avoidRect ? Math.min(rect.top, avoidRect.top) : rect.top;
                const left = Math.min(rect.left, window.innerWidth - 320 - 64);

                let posObj = { left, width: rect.width };

                if (direction === 'bottom') {
                    const top = rect.bottom + 8;
                    posObj.top = top;
                } else {
                    const bottom = window.innerHeight - anchorTop + 8;
                    posObj.bottom = bottom;
                }

                setDropdownPos(posObj);
                setPositionReady(true);
            }
        };

        requestAnimationFrame(updatePosition);

        window.addEventListener('resize', updatePosition);
        window.addEventListener('scroll', updatePosition, true);

        return () => {
            window.removeEventListener('resize', updatePosition);
            window.removeEventListener('scroll', updatePosition, true);
        };
    }, [enquiryOpen, direction]);


    useEffect(() => {
        let timeoutId

        const handleClickOutside = (event) => {
            const clickedOutside =
                actionButtonRef.current &&
                !actionButtonRef.current.contains(event.target) &&
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)

            if (clickedOutside) {
                setEnquiryOpen(false)
            }
        }

        if (enquiryOpen) {
            timeoutId = setTimeout(() => {
                document.addEventListener('mousedown', handleClickOutside)
            }, 0)
        }

        return () => {
            clearTimeout(timeoutId)
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [enquiryOpen])

    if (!positionReady) {
        return null;
    }
    return (
        ReactDOM.createPortal(
            <div
                ref={dropdownRef}
                className={styles.dropdownList}
                style={{
                    position: 'fixed',
                    left: dropdownPos.left,
                    ...(direction === 'bottom' ? { top: dropdownPos.top } : { bottom: dropdownPos.bottom }),
                    width: dropdownPos.width,
                    zIndex: 9999999
                }}
                role="menu"
            >
                {options.map((option, idx) => (
                    <div
                        key={idx}
                        className={`${styles.dropdownItem} ${idx === 0 ? styles.dropdownItemActive : ''}`}
                        onClick={() => {
                            onOptionSelect(idx, option)
                        }}
                        role="menuitem"
                    >
                        {option}
                    </div>
                ))}
            </div>,
            document.body
        )
    )
}
